module.exports = __webpack_public_path__ + "media/images/emblems/Walliswil_bei_Wangen-coat_of_arms-cac5e4dfa313c09236c14dc35fef984e.svg";